import React from "react";import PaymentsTab from "../components/payment/PaymentsTab";
 export default function Payments(){ return <div><PaymentsTab/></div>; }